module.exports = __webpack_public_path__ + "static/Writers-Print (5)-d1f9108402bea89cef7830c06615184f.png";